<div class='grit-badge'>
  <ng-container #iconOutlet [ngTemplateOutlet]="templateOutletRef"></ng-container>
    <span class="badge-content">
      <ng-content></ng-content>
    </span>

    <ng-container *ngIf="showIcon">
      <ng-template #iconOverrideTemplate>
        <ng-content select="pg-icon, .material-icons"></ng-content>
      </ng-template>

      <ng-template #defaultIcon>
        <pg-icon [size]="12">fiber_manual_record</pg-icon>
      </ng-template>

      <ng-template #warnIconDefault>
        <pg-icon [size]="12">warning</pg-icon>
      </ng-template>

      <ng-template #primaryIconDefault>
        <pg-icon [size]="12">fiber_manual_record</pg-icon>
      </ng-template>

      <ng-template #successIconDefault>
        <pg-icon [size]="12">check_circle</pg-icon>
      </ng-template>

      <ng-template #attentionIconDefault>
        <pg-icon [size]="12">info</pg-icon>
      </ng-template>

      <ng-template #attentionStrongIconDefault>
        <pg-icon [size]="12">info</pg-icon>
      </ng-template>

      <ng-template #infoIconDefault>
        <pg-icon [size]="12">info</pg-icon>
      </ng-template>

      <ng-template #progressIcon>
        <pg-badge-progress-indicator
          [progress]="progress"
          [foreground]="getBadgeForeground(type)"
          [background]="getBadgeBackground(type)"
        ></pg-badge-progress-indicator>
      </ng-template>
    </ng-container>

</div>